/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export { default as RadioGroupControlled } from './radio-group-controlled.story';
export { default as RadioGroupDefault } from './radio-group-default.story';
export { default as RadioGroupDisabled } from './radio-group-disabled.story';
export { default as RadioGroupError } from './radio-group-error.story';
export { default as RadioGroupHorizontal } from './radio-group-horizontal.story';
export { default as RadioGroupOptional } from './radio-group-optional.story';
export { default as RadioGroupRequired } from './radio-group-required.story';
export { default as RadioGroupVisuallyHiddenLabel } from './radio-group-visually-hidden-label.story';

import { removeLicenseHeader } from '../../_common/export-stories-utils';
import RadioGroupControlledSrcRaw from './radio-group-controlled.story?raw';
import RadioGroupDefaultSrcRaw from './radio-group-default.story?raw';
import RadioGroupDisabledSrcRaw from './radio-group-disabled.story?raw';
import RadioGroupErrorSrcRaw from './radio-group-error.story?raw';
import RadioGroupHorizontalSrcRaw from './radio-group-horizontal.story?raw';
import RadioGroupOptionalSrcRaw from './radio-group-optional.story?raw';
import RadioGroupRequiredSrcRaw from './radio-group-required.story?raw';
import RadioGroupVisuallyHiddenLabelSrcRaw from './radio-group-visually-hidden-label.story?raw';

export const RadioGroupControlledSrc = removeLicenseHeader(
  RadioGroupControlledSrcRaw,
);
export const RadioGroupDefaultSrc = removeLicenseHeader(
  RadioGroupDefaultSrcRaw,
);
export const RadioGroupDisabledSrc = removeLicenseHeader(
  RadioGroupDisabledSrcRaw,
);
export const RadioGroupErrorSrc = removeLicenseHeader(RadioGroupErrorSrcRaw);
export const RadioGroupHorizontalSrc = removeLicenseHeader(
  RadioGroupHorizontalSrcRaw,
);
export const RadioGroupOptionalSrc = removeLicenseHeader(
  RadioGroupOptionalSrcRaw,
);
export const RadioGroupRequiredSrc = removeLicenseHeader(
  RadioGroupRequiredSrcRaw,
);
export const RadioGroupVisuallyHiddenLabelSrc = removeLicenseHeader(
  RadioGroupVisuallyHiddenLabelSrcRaw,
);
